import React from 'react';
import PropTypes from 'prop-types';
import { Button, Card, Col, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const TabFolios = ({ rnc, onAsignarMas, calcularPorcentaje, getStatusColor }) => {
    if (!rnc) return null;

    const porcentaje = calcularPorcentaje(rnc);
    const disponibles = rnc.dExistencia - rnc.foliosUsados;

    return (
        <div className="mb-4">
            <h6 className="text-muted mb-3">Resumen de folios</h6>
            
            <Card className="bg-light border-0 mb-3">
                <Card.Body>
                    <Row>
                        <Col xs={6}>
                            <div className="text-muted small mb-1">Total asignados</div>
                            <h4 className="mb-0">{rnc.dExistencia ? rnc.dExistencia.toLocaleString() : '0'}</h4>
                        </Col>
                        <Col xs={6}>
                            <div className="text-muted small mb-1">Usados</div>
                            <h4 className="mb-0 text-primary">{rnc.foliosUsados ? rnc.foliosUsados.toLocaleString() : '0'}</h4>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            <div className="mb-3">
                <div className="d-flex justify-content-between mb-2">
                    <span className="text-muted">Disponibles</span>
                    <span className="fw-bold">{disponibles.toLocaleString()}</span>
                </div>
                <div className="progress" style={{ height: '12px' }}>
                    <div 
                        className={`progress-bar bg-${getStatusColor(porcentaje)}`}
                        style={{ width: `${porcentaje}%` }}
                    >
                        {porcentaje}%
                    </div>
                </div>
            </div>

            <div className="alert alert-info">
                <FontAwesomeIcon icon="info-circle" className="me-2" />
                <small>
                    Al ritmo actual, los folios se agotarán en aproximadamente 
                    <strong> 45 días</strong>.
                </small>
            </div>

            <Button 
                variant="primary"
                className="w-100"
                onClick={() => onAsignarMas(rnc)}
            >
                <FontAwesomeIcon icon="plus-circle" className="me-2" />
                Asignar más folios
            </Button>
        </div>
    );
};

TabFolios.propTypes = {
    rnc: PropTypes.object,
    onAsignarMas: PropTypes.func.isRequired,
    calcularPorcentaje: PropTypes.func.isRequired,
    getStatusColor: PropTypes.func.isRequired
};

export default TabFolios;
